import gql from 'graphql-tag'
import { anuncioFragment } from '@/modules/anuncio-core/data/anuncio-fragment'

export const ANUNCIO_ALEATORIO = gql`
  query AnuncioAleatorioQuery {
    anuncioAleatorio {
      ...AnuncioFragment
    }
  }
  ${anuncioFragment}
`
